import React, { Children } from 'react';
import PropTypes from 'prop-types';
/**
 * The Stack component takes an array of children and displays them
 * as visually stacked (one on top of the other) with the last item appearing on top
 */

var Stack = function Stack(props) {
  var children = props.children,
      max = props.max;
  var stackedChildren = Children.toArray(children).slice(0, max).map(function (el, i, arr) {
    var lastIndex = arr.length - 1;
    var offset = (lastIndex - i) * 4;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%',
        position: i === lastIndex ? 'relative' : 'absolute',
        transform: "translate(".concat(offset, "px, ").concat(offset, "px)")
      }
    }, el);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, stackedChildren);
};

Stack.defaultProps = {
  max: 5
};
Stack.propTypes = {
  /**
   * Max number of visible items to show in the stack
   */
  max: PropTypes.number,

  /**
   * The collection of items to display as a "stack"
   */
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};
export default Stack;